export const txExplorersPrefixes = {
    polygon: 'https://polygonscan.com/tx'
}